/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DownloadManagementListContentRequest } from '../models/DownloadManagementListContentRequest';
import type { DownloadManagementListContentResponseApiRespoonse } from '../models/DownloadManagementListContentResponseApiRespoonse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DownloadManagerService {

    /**
     * Get list Contents
     * @param requestBody
     * @returns DownloadManagementListContentResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminDownload(
        requestBody: DownloadManagementListContentRequest,
    ): CancelablePromise<DownloadManagementListContentResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/download',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

}
